import { getMediaUrl } from "@/config/runtimeConfig";

export function extractFilename(url: string): string {
  return url.split("/").pop() || "logo.png";
}

export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export const appendFullImageUrl = (url: string) => {
  return `${getMediaUrl()}/${url}`;
};
